import { Component } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { AssetService } from '../../services/asset.service';
import { Asset } from '../../models/asset.model';
import { LoadingController, Loading, Platform } from "ionic-angular";
import { Alert } from '../../models/alert.model';
import { ProjectService } from '../../services/project.service';
import { Storage } from "@ionic/storage";
import { ISubscription } from 'rxjs/Subscription';
import { SystemService } from '../../services/system.service';
import { TranslateService } from "@ngx-translate/core";

declare let ga: any;
 
@Component({
  selector: 'alerts',
  templateUrl: 'alerts.html',
  providers: [TranslateService]
})
export class AlertsComponent {
  private subscription : ISubscription;
  public project: any;
  public alerts: Alert[];
  public fetchDataSpinner: Loading;
  public asset: Asset;
  public access_token: string;
  public duration: number = 4;
  public spinnerOptions = {
    content: this.translate.instant('Fetchingdata'),
    spinner: 'bubbles'
  }
  public username: string;
  public lan :any;
  constructor(
    private platform: Platform,
    private loadingCtrl: LoadingController,
    private storage: Storage,
    public alertService: AlertService,
    public assetService: AssetService,
    public projectService: ProjectService,
    public systemsService: SystemService,
    public translate: TranslateService
  ) {
    this.asset = this.assetService.get();
    this.project = this.projectService.get();
    
  }

  ngOnInit() {
    this.lan =sessionStorage.getItem("lang")
    //this.lan="cn";
    if (this.platform.is("mobileweb") || this.platform.is("core")) {
      this.access_token = sessionStorage.getItem('access_token');
      this.getDiagnosticAlerts(this.access_token, this.asset.id, 4);
      this.username = JSON.parse(sessionStorage.getItem('id_token_claims_obj')).globalid;
      this.username = this.username.replace("~AAD:","");
      ga('set', 'title', 'Alerts');  
      ga('set', 'page', '/mobile/assets/alerts');
      ga('set', 'dimension1', this.username);
      ga('set', 'dimension2', this.asset.id); 
      ga('send', 'pageview');
    }
    else {
      this.storage.get('access_token').then((token) => {
        this.access_token = token;
        this.getDiagnosticAlerts(this.access_token, this.asset.id, 4);
      })
    }
  }

  getDiagnosticAlerts(token, assetId, duration){
    this.fetchDataSpinner = this.loadingCtrl.create(this.spinnerOptions);
    this.fetchDataSpinner.present();
    this.subscription = this.alertService.getDiagnosticAlerts(token, assetId, duration,this.lan)
      .subscribe((data) => {
        this.alerts = data;
        this.fetchDataSpinner.dismiss();
      }, (error) => this.fetchDataSpinner.dismiss());
  }

  ngOnDestroy(){
      if(!this.subscription.closed){
        this.subscription.unsubscribe();
      }
  }
  selectTimeDuration(event){
    this.alerts = undefined;
    this.duration = event;
    this.getDiagnosticAlerts(this.access_token, this.asset.id, event);
    if(this.duration==4)
    {
        sessionStorage.setItem('trendsTimeDuration', '12');
    }
    else{
      sessionStorage.setItem('trendsTimeDuration', String(this.duration));
    }
    
  }

  changeSystem(asset){
    this.alerts = undefined;
    this.systemsService.set(false);
    this.getDiagnosticAlerts(this.access_token, asset.id, this.duration);
    this.asset = asset;
  }

  showOnboardDiagnostics(alert){
    if(this.platform.is("mobileweb") || this.platform.is("core")){
      sessionStorage.setItem('isOnboardDiagnostic', '1');
      this.alertService.showOnboardDiagnostics.emit(true);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/alerts/alerts.ts